module.exports = __webpack_public_path__ + "img/4.ed4ad4eb.svg";